import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgChartsModule } from 'ng2-charts';

import { SharedModule } from '../shared/shared.module';
import { BillableGraphWidgetComponent } from './billable-graph-widget/billable-graph-widget.component';
import { BusinessDeveloperTargetModalComponent } from './business-developer-target-modal/business-developer-target-modal.component';
import { ChartInformationModalComponent } from './chart-information-modal/chart-information-modal.component';
import { DivisionGraphsComponent } from './division-graphs/division-graphs.component';
import { DivisionDetailModalComponent } from './division-detail-modal/division-detail-modal.component';
import { DivisionTargetModalComponent } from './division-target-modal/division-target-modal.component';
import { EmployeeFinancialGraphsComponent } from './employee-financial-graphs/employee-financial-graphs.component';
import { EmployeeGraphComponent } from './employee-graph/employee-graph.component';
import { EmployeeGraphsComponent } from './employee-graphs/employee-graphs.component';
import { FinancialHomeComponent } from './financial-home/financial-home.component';
import { FinancialSubnavComponent } from './financial-subnav/financial-subnav.component';
import { routing } from './financial.routes';
import { GraphWidgetComponent } from './graph-widget/graph-widget.component';
import { HappinessScoreGraphWidgetComponent } from './happiness-score-graph-widget/happiness-score-graph-widget.component';
import { OverheadFinancialGraphsComponent } from './overhead-financial-graphs/overhead-financial-graphs.component';
import { OverheadGraphWidgetComponent } from './overhead-graph-widget/overhead-graph-widget.component';
import { OverheadGraphsComponent } from './overhead-graphs/overhead-graphs.component';
import { OverheadCategoryBudgetModalComponent } from './overhead-category-budget-modal/overhead-category-budget-modal.component';
import { OverheadCategoryBudgetDetailsModalComponent } from './overhead-category-budget-details-modal/overhead-category-budget-details-modal.component';
import { ProjectFinancialGraphsComponent } from './project-financial-graphs/project-financial-graphs.component';
import { ProjectGraphComponent } from './project-graph/project-graph.component';
import { ProjectGraphsComponent } from './project-graphs/project-graphs.component';
import { ResearchDevelopmentOverviewComponent } from './research-development-overview/research-development-overview.component';
import { TurnoverGraphComponent } from './turnover-graph/turnover-graph.component';
import { JiraProjectsOverviewComponent } from './jira-projects-overview/jira-projects-overview.component';
import { BudgetOverviewComponent } from './budget-overview/budget-overview.component';
import { ContractsOverviewComponent } from './contracts-overview/contracts-overview.component';
import { ProjectBudgetsOverviewComponent } from './project-budgets-overview/project-budgets-overview.component';

@NgModule({
    declarations: [
        EmployeeGraphComponent,
        EmployeeGraphsComponent,
        ProjectGraphComponent,
        FinancialHomeComponent,
        FinancialSubnavComponent,
        OverheadGraphsComponent,
        OverheadGraphWidgetComponent,
        ChartInformationModalComponent,
        ProjectGraphsComponent,
        GraphWidgetComponent,
        BillableGraphWidgetComponent,
        BusinessDeveloperTargetModalComponent,
        HappinessScoreGraphWidgetComponent,
        EmployeeFinancialGraphsComponent,
        ProjectFinancialGraphsComponent,
        ResearchDevelopmentOverviewComponent,
        OverheadFinancialGraphsComponent,
        OverheadCategoryBudgetModalComponent,
        OverheadCategoryBudgetDetailsModalComponent,
        TurnoverGraphComponent,
        DivisionGraphsComponent,
        DivisionDetailModalComponent,
        DivisionTargetModalComponent,
        JiraProjectsOverviewComponent,
        BudgetOverviewComponent,
        ContractsOverviewComponent,
        ProjectBudgetsOverviewComponent,
    ],
    exports: [EmployeeGraphComponent, ProjectGraphComponent, OverheadGraphWidgetComponent, HappinessScoreGraphWidgetComponent],
    imports: [routing, NgChartsModule, SharedModule, CommonModule, NgbNavModule, NgbDropdownModule, MatTableModule, MatSortModule, MatTooltipModule],
})
export class FinancialModule {}
